// index.js
import { registerBlockType } from '@wordpress/blocks'
import { __ } from '@wordpress/i18n'

import Edit from './edit'
import Save from './save'

import { DEFAULT_BREAKPOINT_SIZES } from './lib/constants'

registerBlockType('swd/dualaxis-spacer', {
  title: __('Dual-Axis Spacer', 'swd-dualaxis-spacer'),
  description: __('A spacer block that allows for dual axis spacing.', 'swd-dualaxis-spacer'),
  icon: 'format-image',
  category: 'layout',
  keywords: [__('spacer', 'swd-dualaxis-spacer'), __('dual axis', 'swd-dualaxis-spacer')],
  attributes: {
    breakpoints: {
      type: 'array',
      default: ['mobile', 'tablet', 'desktop']
    },
    breakPointSizes: {
      type: 'object',
      default: DEFAULT_BREAKPOINT_SIZES
    },
    doSiblingMaxWidth: {
      type: 'boolean',
      default: false
    },
    blockSizes: {
      type: 'object',
      default: {
        small: { width: 20, height: 20 },
        medium: { width: 40, height: 40 },
        large: { width: 60, height: 60 }
      }
    },
    blockId: {
      type: 'string',
      default: ''
    },
    isolationMode: {
      type: 'boolean',
      default: false
    },
    lastEditedBreakpoint: {
      type: 'string',
      default: 'small'
    }
  },
  edit: Edit,
  save: Save,
  deprecated: [
    {
      attributes: {
        // Same as your original attributes
      },

      save: () => null
    }
  ]
})
